import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=f24a2660"
import script from "./Orders.js?vue&type=script&lang=js&external"
export * from "./Orders.js?vue&type=script&lang=js&external"
import style0 from "./Orders.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports